import classNames from 'classnames';
import React from 'react';
import FloatingCard from '../../components/FloatingCard';
import HoverView from '../../components/HoverView';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import SeriesHoverCard from '../../series/SeriesHoverCard';
import * as styles from './PostSeriesMeta.module.scss';

const SERIES_FIELDS_FRAGMENT = gql(`
  fragment PostSeriesMeta_series on SeriesFields {
    id
    name
  }
`);

interface PostSeriesMetaProps {
  postId: string;
  series: DocumentType<typeof SERIES_FIELDS_FRAGMENT>;
  singleLine?: boolean;
  showHoverCard?: boolean;
}

const PostSeriesMeta = ({
  postId,
  series,
  singleLine = false,
  showHoverCard = false,
}: PostSeriesMetaProps) => {
  if (!series) {
    return null;
  }

  const inner = (
    <div
      className={classNames(styles.container, {
        [styles.hoverable]: showHoverCard,
        [styles.singleLine]: singleLine,
      })}
    >
      {`Part of ${series.name}`}
    </div>
  );

  return showHoverCard ? (
    <HoverView
      placement="bottom-start"
      hoverGroupId="postSeriesMeta"
      view={
        <FloatingCard noArrow className={styles.hoverView}>
          <SeriesHoverCard postId={postId} />
        </FloatingCard>
      }
    >
      {inner}
    </HoverView>
  ) : (
    inner
  );
};

export default PostSeriesMeta;
